import React, { Fragment, useState } from 'react';
import Header from '../Components/Heading';
import Link from '../Components/Link';
import TextInput from '../Components/TextInput';
import { useNavigate } from 'react-router-dom';
import DropDown from '../Components/DropDown';
import ReportsSection from '../Components/ReportsSection'
import Select from 'react-select';
import { domains } from '../configs/domains';
import GrowingPages from '../Components/GrowingPages';
import PendingApprovals from '../Components/PendingApprovals';
import KayakingGeo from '../Components/KayakingGeo';


const wrapperStyle = { backgroundColor: '#ddd', padding: '10px', border: '1px solid #444', margin: '10px' };
export default function Dashboard() {
	const navigate = useNavigate();
	const [updateArticleId, setUpdateArticleId] = useState(null);
	const [updatePageUrl, setUpdatePageUrl] = useState(null);
	const [updatePageDomain, setUpdatePageDomain] = useState(null);

	const [updateBrand, setUpdateBrand] = useState(null);
	const [updateBrandDomain, setUpdateBrandDomain] = useState(null);

	const [snippetId, setSnippetId] = useState(null);
	const [updateProductUrl, setUpdateProductUrl] = useState(null);
	const update = (e) => {
		setUpdateArticleId(e.target.value);
	};
	const updatePageUrlFn = (e) => {
		setUpdatePageUrl(e.target.value);
	};

	const updateBrandUrlFn = (e) => {
		setUpdateBrand(e.target.value);
	};

	const updateProductUrlFn = (e) => {
		setUpdateProductUrl(e.target.value);
	};

	return (
		<div >
			<Header text="Dashboard" type="h1" />
			<PendingApprovals />
			<GrowingPages />
			<div style={wrapperStyle}>
				<div style={{ padding: "15px" }}>
					<Header text="My Items" type="h2" />
					<Link href="/how-to" text="Tutorials" /><br />

					<Link text="My recent snippets" href="/my-recent-snippets" />
				</div>
			</div>
			<div style={wrapperStyle}>
				<div style={{ padding: "15px" }}>
					<Header text="Articles" type="h2" /></div>
				<div className="grid grid-cols-1 divide-y">
					<div style={{ padding: '15px' }}>
						<Header text="- Article Management" type="h2" />
						<div className="grid grid-cols-2 divide-x">
							<div className="flex mt-3 items-center">
								<Link text="Create Article" href="/create-article" />
							</div>
							<div className="flex mt-3 items-center">
								<div className="mr-2">Update Article</div>
								<div className="mr-2">
									<TextInput value={updateArticleId} onChange={update} placeholder={'Article Id'} />
								</div>
								<div>
									<button
										onClick={(e) => {
											navigate(`/update-article/${updateArticleId}`);
										}}
										className="bg-blue-500 mt-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
									>
										Submit
									</button>
								</div>
							</div>
						</div>
					</div>


					<div style={{ padding: '15px' }}><Header text="- Current Authors" type="h3" />
						<div>
							<Link href="/authors" text="Authors" />
						</div>
					</div>

					<div style={{ padding: '15px' }}>
						<Header text="- Article Snippets" type="h3" />
						<div className="grid grid-cols-2 divide-x">
							<div className="flex mt-3 items-center">
								<div className="mr-2">Update Snippet</div>
								<div className="mr-2">
									<TextInput
										value={snippetId}
										onChange={(e) => {
											setSnippetId(e.target.value);
										}}
										placeholder={'Snippet Id'}
									/>
								</div>
								<div>
									<button
										onClick={(e) => {
											navigate(`/update-snippet/${encodeURIComponent(snippetId)}`);
										}}
										className="bg-blue-500 mt-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
									>
										Submit
									</button>
								</div>
							</div>

							<div>
								<div>
									<Link href="/create-author-snippet" text="Create Author snippet" />
								</div>
								<div>
									<Link href="/create-image-affiliate-offer-snippet" text="Create Image Affiliate Offer Snippet" />
								</div>
								<div>
									<Link href="/create-category-header-snippet" text="Create Category Header snippet" />
								</div>
								<div>
									<Link href="/create-embedded-related-snippet" text="Create Embedded Related snippet" />
								</div>
								<div>
									<Link href="/create-faqs-snippet" text="Create Faqs snippet" />
								</div>
								<div>
									<Link href="/create-featured-article-snippet" text="Create Featured Article snippet" />
								</div>
								<div>
									<Link href="/create-featured-paragraph-snippet" text="Create Featured Paragraph snippet" />
								</div>
								<div>
									<Link
										href="/create-highlight-with-left-border-snippet"
										text="Create Highlight With Left Border Snippet"
									/>
								</div>
								<div>
									<Link href="/create-image-snippet" text="Create Image snippet" />
								</div>
								<div>
									<Link href="/create-related-cards-snippet" text="Create Related Cards snippet" />
								</div>
								<div>
									<Link href="/create-youtube-snippet" text="Create Youtube Snippet" />
								</div>
								<div>
									<Link href="/create-contact-snippet" text="Create Contact Snippet" />
								</div>
								<div>
									<Link href="/create-map-snippet" text="Create Map Snippet" />
								</div>
							</div></div>

					</div></div>
			</div>
			<KayakingGeo />
			<div style={wrapperStyle}>
				<div style={{ padding: "15px" }}>
					<Header text="Products" type="h2" />
				</div>
				<div style={{ padding: '15px' }}>
					<div>
						<Link text="Create Product" href="/create-product" />
					</div>
					<div className="flex mt-3 items-center">
						<div className="mr-2">Update Product</div>
						<div className="mr-2">
							<TextInput value={updateProductUrl} onChange={updateProductUrlFn} placeholder="Product full url" />
						</div>
						<div>
							<button
								onClick={(e) => {
									navigate(`/update-product?url=${encodeURI(updateProductUrl)}`);
								}}
								className="bg-blue-500 mt-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
							>
								Submit
							</button>
						</div>
					</div>
				</div>
				<div style={{ padding: '15px' }}>
					<Link text="Create Brand" href="/create-brand" />
					<div className="items-center">
						<div className="mr-2">Update Brand</div>
						<div>
							<Select
								className="form-control border rounded"
								options={domains}
								value={domains.filter((option) => option.value === updateBrandDomain)}
								name={"domain"}
								id={"domain"}
								placeholder={"Domain"}
								onChange={(data) => { setUpdateBrandDomain(data.value) }}
							/>
							<div className="mr-2">
								<TextInput value={updateBrand} onChange={updateBrandUrlFn} placeholder={'Brand url'} />
							</div>
						</div>
						<div>
							<button
								onClick={(e) => {
									navigate(`/update-brand/${encodeURIComponent(updateBrandDomain)}/${encodeURIComponent(updateBrand)}`);
								}}
								className="bg-blue-500 mt-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
							>
								Submit
							</button>
						</div>
					</div>
				</div>
			</div>
			<div style={wrapperStyle}>
				<div style={{ padding: "15px" }}>
					<Header text="Pages" type="h2" />
					<p>The main differnce between articles and pages, is that articles are searchable. Also, articles will always live under {`{domain}/article/{slug}-{articleid}`}. Pages can live anywhere except
						for /article/, /products/, /tag/, /tags/, /brand/, and any other prefix specific to the domain it lives in.</p>
				</div>
				<div className="grid grid-cols-1 divide-y">
					<div style={{ padding: '15px' }}>
						<Header text="- Page Management" type="h2" />
						<div className="grid grid-cols-2 divide-x">
							<div className="flex mt-3 items-center">
								<Link text="Create Page" href="/create-page" />
							</div>
							<div className="items-center">
								<div className="mr-2">Update Page</div>
								<div>
									<Select
										className="form-control border rounded"
										options={domains}
										value={domains.filter((option) => option.value === updatePageDomain)}
										name={"domain"}
										id={"domain"}
										placeholder={"Domain"}
										onChange={(data) => { setUpdatePageDomain(data.value) }}
									/>
									<div className="mr-2">
										<TextInput value={updatePageUrl} onChange={updatePageUrlFn} placeholder={'Page url'} />
									</div>
								</div>
								<div>
									<button
										onClick={(e) => {
											navigate(`/update-page/${encodeURIComponent(updatePageDomain)}/${encodeURIComponent(updatePageUrl)}`);
										}}
										className="bg-blue-500 mt-2 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
									>
										Submit
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<ReportsSection />
		</div>
	);
}
